import type { DeviceFragment, DeviceGeneralStatus } from '@cobliteam/api-lib/src/__generated__/graphql';
import type { Destination, Vehicle } from '@cobliteam/common-types';
import type { StateCreator } from 'zustand';
import SortType from '../../types/SortType';
import type { MonitoringSlices } from '.';

interface VehiclesFilters {
  vehicles: Vehicle[];
  vehicleGroupIds: string[]; // Vehicle group IDs
  deviceStatus: DeviceGeneralStatus[];
  searchBox?: string;
  sort: SortType;
}

interface VehiclesSlice {
  vehiclesFilters: VehiclesFilters;
  setVehiclesFilters: (filters: Partial<VehiclesFilters>) => void;
  clearVehiclesFilters: () => void;

  etaDialog: boolean;
  setEtaDialog: (etaDialog: boolean) => void;

  destination?: Destination;
  setDestination: (destination?: Destination) => void;

  selectedDevice?: DeviceFragment;
  setSelectedDevice: (device?: DeviceFragment) => void;
}

type StateCreatorVehicles = StateCreator<MonitoringSlices, [['zustand/devtools', never]], [], VehiclesSlice>;

const createVehiclesSlice: StateCreatorVehicles = (set) => ({
  vehiclesFilters: {
    vehicles: [],
    vehicleGroupIds: [],
    deviceStatus: [],
    searchBox: '',
    sort: SortType.ON,
  },
  setVehiclesFilters: (filters: Partial<VehiclesFilters>) =>
    set((state) => ({
      vehiclesFilters: { ...state.vehiclesFilters, ...filters },
    })),
  clearVehiclesFilters: () =>
    set(() => ({
      vehiclesFilters: {
        vehicles: [],
        vehicleGroupIds: [],
        deviceStatus: [],
        searchBox: '',
        sort: SortType.ON,
      },
    })),

  etaDialog: false,
  setEtaDialog: (etaDialog: boolean) => set({ etaDialog }),

  destination: undefined,
  setDestination: (destination?: Destination) => set({ destination }),

  selectedDevice: undefined,
  setSelectedDevice: (device?: DeviceFragment) => set({ selectedDevice: device }),
});

export type { VehiclesFilters, VehiclesSlice };
export default createVehiclesSlice;
